import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreKeysEnum } from '../../../../store/store-keys'
import { DirectivesUpgradedModule } from '../../../../shared/directives/directivesUpgraded.module'
import { OrderByPipeModule } from '../../../../shared/pipes/order-by-pipe.module'
import { DisplayNamePipeModule } from '../../../subject/pipes/display-name.module'
import { DisplayNumberModule } from '../../../../shared/pipes/display-number.module'
import { AttachmentTypeScanDataComponent } from './attachment-type-scan-data.component'
import { commonDomainComponentsReducer } from './state/common-domain-components.reducers'
import { CommonDomainComponentsEffects } from './state/common-domain-components.effects'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        StoreModule.forFeature(StoreKeysEnum.CommonDomainComponents, commonDomainComponentsReducer),
        EffectsModule.forFeature([CommonDomainComponentsEffects]),
        DirectivesUpgradedModule,
        OrderByPipeModule,
        DisplayNamePipeModule,
        DisplayNumberModule,
    ],
    declarations: [AttachmentTypeScanDataComponent],
    exports: [AttachmentTypeScanDataComponent],
})
export class AttachmentTypeScanDataModule {}
